import React from 'react';
import { graphql, useFragment } from 'react-relay';
import Badge from '@atlaskit/badge';
import { useIntl } from '@atlassian/jira-intl';
import type { StoryPointsGroupHeader$key } from './__generated__/StoryPointsGroupHeader.graphql';
import messages from './messages.tsx';

export type Props = {
	storyPointsGroupHeader: StoryPointsGroupHeader$key | null;
};

export const StoryPointsGroupHeader = ({ storyPointsGroupHeader }: Props) => {
	const data = useFragment<StoryPointsGroupHeader$key>(
		graphql`
			fragment StoryPointsGroupHeader on JiraJqlNumberFieldValue {
				number
			}
		`,
		storyPointsGroupHeader,
	);

	const { formatMessage } = useIntl();

	return (
		<Badge appearance="default">
			{typeof data?.number === 'number'
				? formatMessage(messages.storyPoints, {
						points: data?.number,
					})
				: formatMessage(messages.noStoryPoints)}
		</Badge>
	);
};
